import { t } from '@/lib/i18n';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth-layout';
import { DeviceAuthorizationForm } from '@/features/auth/device-authorization/form';
import { requirePasswordChanged, requireSession } from '@/features/auth/session/guards';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_auth/device')({
  validateSearch: (search: Record<string, unknown>) => ({
    user_code:
      typeof search.user_code === 'string' && search.user_code.length <= 191
        ? search.user_code
        : undefined,
  }),
  beforeLoad: async ({ context, location }) => {
    const session = await requireSession(context.queryClient, location.href);
    requirePasswordChanged(session, location.href, location.pathname);
  },
  component: DevicePage,
});

function DevicePage() {
  useDocumentTitle(t('设备授权'));
  const { user_code } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <AuthLayout title={t('设备授权')} subtitle={t('核对设备上的授权码')}>
      <DeviceAuthorizationForm
        key={user_code}
        initialCode={user_code}
        onComplete={async () => {
          await navigate({ to: '/profile' });
        }}
      />
    </AuthLayout>
  );
}
